import { render } from "./CurrencyList.vue?vue&type=template&id=51d6c436&ts=true"
import script from "./CurrencyList.vue?vue&type=script&lang=ts"
export * from "./CurrencyList.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__